/* eslint-disable no-unused-vars */
// -----------------------------------------------------------------------------
export enum NoRecommendationReasons {
  FailedToQueryServer = 'FailedToQueryServer',
  NoGameConfig = 'NoGameConfig',
  CooldownCrashed = 'CooldownCrashed',
  CooldownInitial = 'CooldownInitial',
  CooldownDisplay = 'CooldownDisplay',
  CooldownOWLaunch = 'CooldownOWLaunch',
  UserPersistentPhasing = 'UserPersistentPhasing',
  NoRelevantApp = 'NoRelevantApp',
  PortfolioExhausted = 'PortfolioExhausted',
  FailedToGetServiceConfig = 'FailedToGetServiceConfig',
  SpecificApplicationAlreadyDownloaded = 'SpecificApplicationAlreadyDownloaded',
  CapLimitReached = 'CapLimitReached',
  DedicatedAppAlreadyInstalled = 'DedicatedAppAlreadyInstalled',
  AppAlreadyInstalled = 'AppAlreadyInstalled',
  ErrorNoAppContext = 'ErrorNoAppContext',
  GPUNotSupported = 'GPUNotSupported',
  DismissedByUser = 'DismissedByUser',
  BlackListedApp = 'BlackListedApp',
  NoAppToRecommend = 'NoAppToRecommend',
  GameIsRunning = 'GameIsRunning',
  MinimumGameSessionLengthNotReached = 'MinimumGameSessionLengthNotReached',
  GameConfiguredToShowOnStart = 'GameConfiguredToShowOnStart',
  GameExcludedByUser = 'GameExcludedByUser',
  AppExcludedByUser = 'AppExcludedByUser',
  GeoRestricted = 'GeoRestricted',
  PreviouslyDisplayed = 'PreviouslyDisplayed',
  MinimumAdUniteDisplayNotReached = 'MinimumAdUniteDisplayNotReached',
  GameEventsInfoNotFound = 'GameEventsInfoNotFound',
  CTAPreviouslyClicked = 'CTAPreviouslyClicked',
  ConfiguredForStart = 'ConfiguredForStart',
  ConfiguredForEnd = 'ConfiguredForEnd',
  ApprovedByUser = 'ApprovedByUser',
  OfferNotApproved = 'OfferNotApproved',
  InGameRecommendationsDisabled = 'InGameRecommendationsDisabled',
}
